import { ResourceBase } from '../../resource-types';
import { RawModel } from '../schema';

export interface GenerativeModal extends ResourceBase {}

export const generativeModal: RawModel = {
  type: 'generative-model',
  plural: 'generative-models',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'string'
  },
  relationships: {}
};
